import { MessageService } from 'primeng/api';
import { Component, NgModule, Input, OnInit, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, FormGroup, ReactiveFormsModule, FormArray, FormControl, Validators, } from '@angular/forms';
import { BaseFormComponent } from '../../../models/base/base-form.component';
import { SimpleControlModule } from './dynamic/simple-control.component';
import { DynamicDateFormModule } from './dynamic-date-form.componet';
import { LoadingModule } from './loading.component';
import { DynamicValueModule } from './dynamic/dynamic-value.component';
import { DynamicControlErrorModule } from './dynamic/dynamic-control-error.component';
import { UploadsModule } from '../controls/uploads.component';
import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { OrderService } from '../../../services/order.service';
import { UserService } from '../../../services/user.service';
import { FileService } from '../../../services/file.service';
import { LookupService } from '../../../services/lookup.service';
import { SharedService } from '../../../services/shared.service';
import { FormHelperService } from '../../../services/form-helper.service';
import { NavigationService } from '../../../services/navigation.service';
import { environment } from '../../../environments/environment';
import { PaymentMethod } from '../../invoices/invoice-form.component';
import * as Sentry from '@sentry/angular';
import { DriverTruckOverhualFormModule } from './driver-truck-overhual-form.componet';
import { ConfirmDeleteDialogModule } from './confirm-delete-dialog.component';
import { SanitizeInputDirective } from '../../../directives/sanitize-input.directive';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'dynamic-bulk-upload',
  templateUrl: './dynamic-bulk-upload.component.html',
  providers: [OrderService, UserService, FileService, LookupService]
})
export class DynamicBulkUploadComponent extends BaseFormComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  @Input() orders: any[] = []
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSaveComplete: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup = new FormGroup({});
  dynamicBulkUploadrray: FormArray = null;
  isLoading: boolean = false;
  orderIds = [];
  orderGuiIds = [];
  assignedCarrierPhones = [];
  assignedCarrierPhone = null;
  mcNumber = null;
  businessPhone = null;
  uploads: any[] = [];
  startTime: number;
  totalTime: number = 2700;
  assignedCargoLimit = [];
  cargoInsuranceDeductible = [];
  isDispatched = false;
  modal = null;
  metadata: any = {};
  showCancelWarningDailog = false;
  isShareCarrierTerms = false;
  isSendNotification = false;
  isShowWarning = false;
  isDoNotUseCarrier = false;
  isTransitCompleteCarrier: boolean = true;
  carrierItems: any[] = [];
  private forbiddenSub: Subscription;
  dateOverhaulOrderNumber: number = environment.dateOverhaulOrderNumber;
  bookedDispatchOrderNumber: number = environment.bookedDispatchOrderNumber;
  truckOverhaulOrderNumber:number = environment.truckOverhaulOrderNumber;
  orderConfirmDeliveryNumber: number = environment.orderConfirmDeliveryNumber;
  email_pattern = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  hasActiveDriver: boolean = true;
  isNewRecordForTruckOverhual: boolean = false
  policyDetails: any[]=[];
  isPolicyExpired: boolean = false;
  isPolicyEmpty: boolean = false;
  deleteId: number;
  showDeleteWarning: boolean = false;


  constructor(protected messageService: MessageService, private orderService: OrderService, private fh: FormHelperService, private ref: ChangeDetectorRef, private userService: UserService,
    private fileService: FileService, private lookupService: LookupService, private datePipe: DatePipe, private navigationService: NavigationService,
    private sharedService: SharedService) {
    super();
  }

  ngOnInit() {
    this.forbiddenSub = this.sharedService.forbidden$.subscribe(() => this.cancel());
    this.isLoading = true;
    this.loadLookup('yesNoNa');
    this.loadLookup('paymentMethod');
    this.loadLookup('paymentTerms');
    this.loadLookup('bookedBy');
    
    if (this.orders.length === 0) {
      return;
    }

    this.orders.forEach((order) => {
      if (order.number > this.truckOverhaulOrderNumber) {
        this.isNewRecordForTruckOverhual = true;
      }
    })
    
    this.orderIds = this.orders.map((res) => res.id);
    this.orderGuiIds = this.orders.map((res) => res.guid);
    
    // Load carriers
    this.userService.carriers().subscribe({
      next: (r) => {
        this.lookups['carriers'] = r.body;
      },
      error: (error) => {
        Sentry.captureException(error);
        console.error("Error loading carriers:", error);
      }
    });
    
    // Load agents  
    this.userService.agents().subscribe({
      next: (r) => {
        this.lookups['agents'] = r.body;
      },
      error: (error) => {
        Sentry.captureException(error);
        console.error("Error loading agents:", error);
      }
    });
    
    // Load bulk edit data
    this.orderService.getBulkEdit(this.orderIds).subscribe({
      next: (res) => {
        this.modal = res.body.result.orderDetails;
        this.metadata = res.body.result.metadata;
        this.load(res.body.result.orderDetails);
        this.isLoading = false;
        this.startTime = Date.now();
        this.timer();
        this.ref.markForCheck();
      },
      error: (error) => {
        Sentry.captureException(error);
        console.error("Error in getBulkEdit API call:", error);
        const messages = error?.error?.message?.split(';').map(m => m.trim()).filter(m => m);
        messages.forEach(message => {
          this.messageService.add(this.toast(false, message));
        });
        this.isLoading = false;
        this.onCancel.emit([]);
      }
    });
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe((r: any) => {
        this.lookups[key] = r
      });
  }


  timer() {
    const currentTime = Date.now();
    const elapsedTime = (currentTime - this.startTime) / 1000;
    this.totalTime -= elapsedTime;

    if (this.totalTime <= 0) {
      this.totalTime = 0;
      this.cancel();
    }

    this.startTime = currentTime;

    if (this.totalTime > 0) {
      requestAnimationFrame(() => this.timer());
    }
  }

  displayTimer(): string {
    const minutes = Math.floor(this.totalTime / 60);
    const seconds = Math.floor(this.totalTime % 60);

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds.toString();
    return `${formattedMinutes}:${formattedSeconds}`;
  }


  changeUploads(rows: any[]) {
    if (rows == null)
      return;
    rows.forEach(x => x.id = 0);
    this.uploads = rows.filter(r => r.id != null);
  }

  load(model: any) {
    this.form = new FormGroup({}, []);
    this.form.addControl('dispatcherName', new FormControl(null, [Validators.required]));
    this.form.addControl('dispatcherPhone', new FormControl(null, [Validators.required, Validators.minLength(10),Validators.maxLength(18)]));
    this.form.addControl('dispatcherEmail', new FormControl(null, [Validators.required, Validators.email]));
    this.form.addControl('selectedCarrier', new FormControl(null, [Validators.required]));
    this.form.addControl('assignedCarrier', new FormControl(null, [Validators.required]));
    this.form.addControl('paymentTerms', new FormControl(null, [Validators.required]));
    this.form.addControl('carrierEmails', new FormArray([]));
    this.form.addControl('includeBoL', new FormControl(false));
    this.form.addControl('includePort', new FormControl(false));
    this.form.addControl('includeRidgeville', new FormControl(false));

    let bulkEditForm = [];
    if (model?.length > 0) {
      model?.forEach(r => {
        r.dateOverhaulOrderNumber = this.dateOverhaulOrderNumber;
        r.truckOverhaulOrderNumber=this.truckOverhaulOrderNumber
        bulkEditForm.push(this.fh.getDynamicBulkUpload(r));
      });
    }
    this.form.addControl("bulkEditOrders", new FormArray(bulkEditForm));

    this.dynamicBulkUploadrray = this.form.get('bulkEditOrders') as FormArray;

    this.dynamicBulkUploadrray.controls.forEach((control, index) => {
      if (this.form.get("paymentTerms")) {
        this.form.get("paymentTerms").valueChanges.subscribe(() => {
          this.calculatePriceToCarrier(index);
          this.calculateCompanyProfit(index);
        });
      }
    });

    this.dynamicBulkUploadrray.controls.forEach((res, i) => {
      this.calculatePriceToCarrier(i);
    });
    this.form.markAllAsTouched();
    this.ref.detectChanges();

  }

  get getCarrierEmail(): FormArray {
    return this.form.get('carrierEmails') as FormArray;
  }
  addCarrierEmail() {
    this.getCarrierEmail.push(new FormControl(null, [Validators.pattern(this.email_pattern)]));
  }
  removeCarrierEmail(i: number) {
    this.getCarrierEmail.removeAt(i);
  }

  confirmDelete(id: number) {
    this.deleteId = id;
    this.showDeleteWarning = true;
  }
  
   onDeleteConfirm(confirm: boolean) {
    if (confirm && this.deleteId != null) {
      this.removeCarrierEmail(this.deleteId);
      this.deleteId = null;
    }
    this.showDeleteWarning = false;
  }

  setValuesOnCarrierChange(v: any) {
    if (v != null && v > 0 && this.lookups.carriers != null) {
      let c = this.lookups.carriers.find(c => c.value == v);
      if (c != null) {
        this.assignedCarrierPhones = this.getStringArray(c.additionalPhones, ';');
        this.assignedCargoLimit = this.getStringArray(c.cargoInsuranceLimit, ';');
        this.cargoInsuranceDeductible = this.getStringArray(c.cargoInsuranceDeductible, ';');
        let temparr = [];
        let arr = [];
        arr = this.assignedCargoLimit.length > this.cargoInsuranceDeductible.length ? this.assignedCargoLimit : this.cargoInsuranceDeductible;
        for (let index = 0; index < arr.length; index++) {
          let obj = [];
          obj = [this.assignedCargoLimit[index] ? '$ ' + this.assignedCargoLimit[index] + ' ' : '- ', this.cargoInsuranceDeductible[index] ? ' $ ' + this.cargoInsuranceDeductible[index] : ' -'];
          temparr.push(obj);
        }
        this.assignedCargoLimit = temparr;
        this.assignedCarrierPhone = c.phone;
        this.mcNumber = c.mcDotNumber;

        this.businessPhone = c.businessPhone;
      } else {
        this.assignedCarrierPhone = null;
        this.assignedCarrierPhones = [];
        this.assignedCargoLimit = [];
        this.cargoInsuranceDeductible = [];
        this.businessPhone = null;
      }
    } else {
      this.assignedCarrierPhone = null;
      this.assignedCarrierPhones = [];
      this.assignedCargoLimit = [];
      this.cargoInsuranceDeductible = [];
      this.businessPhone = null;
      this.mcNumber = null
    }
  }

  carrierSearch(e: any){
    const query = e.query?.trim().toUpperCase();
  
    this.carrierItems = (!query || !this.lookups?.carriers)
      ? []
      : this.lookups.carriers.filter(carrier => carrier?.label?.toUpperCase().includes(query));
  }

  onClearCarrier(){
    this.form.get("assignedCarrier").setValue(null);
    this.form.get("selectedCarrier").setValue(null);
    this.form.get('paymentTerms').setValue(null);
    this.onCarrierChange(null, this.lookups.carriers);
    this.form.get("assignedCarrier").updateValueAndValidity();
    this.form.get("selectedCarrier").updateValueAndValidity();
    this.policyDetails = [];
    this.resetDriverFormsAndValidation();
  }

  carrierSelect(e: any) {
    const selectedCarrierControl = this.form.get("selectedCarrier");
    const assignedCarrierControl = this.form.get("assignedCarrier");

    if (selectedCarrierControl && assignedCarrierControl) {
      const previousAssignedCarrier = assignedCarrierControl.value;

      assignedCarrierControl.setValue(e.value);
      selectedCarrierControl.setValue(e);

      assignedCarrierControl.markAsDirty();
      selectedCarrierControl.markAsDirty();

      assignedCarrierControl.updateValueAndValidity();
      selectedCarrierControl.updateValueAndValidity();
      if (!this.isNewRecordForTruckOverhual) {
        this.loadCarrierDriversAndPolicies(e.value);
      }
      if (previousAssignedCarrier !== e.value) {
        this.resetDriverFormsAndValidation();
      }
      this.form.get('paymentTerms').setValue(e?.paymentTerms);
      this.onCarrierChange(e.value, this.lookups.carriers);
    }
  }

  onCarrierChange(value: any, items: any) {
    this.isDoNotUseCarrier = false;
    this.setValuesOnCarrierChange(value);
    if (value && items && Array.isArray(items) && items.length > 0) {
      const item = items?.filter(ele => ele.value == value);
      if (item.length > 0) {
        if (item[0].carrierStatus == 5) {
          this.isDoNotUseCarrier = true;
          // this.form.controls['assignedCarrier'].setErrors({ 'incorrect': 'Please select another carrier. This carrier mark as do not use.' });
        } else {
          // Uncomment below code once carrier upload doc feature rolled out on a production
          // if (item[0].insuranceExpirationDate) {
          //   const today = new Date();
          //   today.setHours(0, 0, 0, 0);
          //   today.setDate(today.getDate() + 3);
          //   if (new Date(item[0].insuranceExpirationDate).getTime() < today.getTime()) {
          //     this.form.controls['assignedCarrier'].setErrors({ 'incorrect': 'Please update insurance certificate for this carrier.' });
          //   }
          // } else {
          //   this.form.controls['assignedCarrier'].setErrors({ 'incorrect': 'Please update insurance certificate for this carrier.' });
          // }
        }
      }
    }
  }


  cancel() {
    this.form = new FormGroup({}, []);
    this.ref.markForCheck();
    this.onCancel.emit(this.orderIds);
  }

  onPolicyDetailsChange(event){
    this.policyDetails = event?.policyDetails;
    this.isPolicyExpired = this.policyDetails?.some((item) => item.isExpire);
    this.isPolicyEmpty = this.policyDetails?.length === 0;
    this.isTransitCompleteCarrier = event?.carrierUploadComplete;
  }

  cancelClick() {
    if (!this.isDispatched) {
      this.showCancelWarningDailog = true;
    } else if (this.isDispatched && (!this.isShareCarrierTerms || !this.isSendNotification)) {
      this.isShowWarning = true;
    } else {
      this.cancel();
    }
  }

  save(status: number) {
    this.isLoading = true;
    const f = this.form.value;
    f.orderIds = this.orderIds;
    f.attachments = this.uploads;
    f.carrierEmails = this.getArrayString(this.getCarrierEmail?.controls?.map((r) => { return r.value; }));
    f.bulkEditOrders.forEach((res) => {
      if (res.brokerFeePaidDate) {
        res.brokerFeePaidDate = this.datePipe.transform(res.brokerFeePaidDate, 'yyyy-MM-dd');
      }
    })
    f.status = status;
    this.orderService.saveBulkEdit(f).subscribe((res) => {
      if (res?.body) {
        this.messageService.add(this.toast(true, res?.body));
      } else {
        this.messageService.add(this.toast(true, 'Bulk orders send to dispatched successfully'));
      }
      this.isDispatched = true;
      this.form.disable();
      this.isLoading = false;
      this.sharedService.getMenuCount('order').subscribe(res => {
        this.navigationService.menuCountChange(res.body, 'order');
      });
      this.onSaveComplete.emit(false);
      this.ref.markForCheck();
    }, err => {
      Sentry.captureException(err);
      this.isLoading = false;
      this.ref.markForCheck();
      if (err?.error?.message != null) {
        this.messageService.add(this.toast(true, err.error.message));
      } else if (err?.status == 500) {
        this.messageService.add(this.toast(true, 'Internal Server Error'));
      }
    })
  }

  sendAttachments() {
    this.isLoading = true;
    this.fileService.sendAttachmentsMailBulkEdit(this.orderGuiIds, this.form.get('includeBoL').value, this.form.get('includePort').value, this.form.get('includeRidgeville').value).subscribe((res) => {
      if (res?.body) {
        this.messageService.add(this.toast(true, res?.body));
      } else {
        this.messageService.add(this.toast(true, 'Email send successfully'));
      }
      this.isLoading = false;
      this.isShareCarrierTerms = true;
      this.ref.markForCheck();
    }, err => {
      Sentry.captureException(err)
      this.isLoading = false;
      this.ref.markForCheck();
      if (err?.error?.message != null) {
        this.messageService.add(this.toast(true, err.error.message));
      } else if (err?.status == 500) {
        this.messageService.add(this.toast(true, 'Internal Server Error'));
      }
    })
  }
  sendDispatchedMail() {
    this.isLoading = true;
    this.fileService.sendDispatchMailBulkEdit(this.orderGuiIds).subscribe((res) => {
      if (res?.body) {
        this.messageService.add(this.toast(true, res?.body));
      } else {
        this.messageService.add(this.toast(true, 'Email send successfully'));
      }
      this.isLoading = false;
      this.isSendNotification = true;
      this.ref.markForCheck();
    }, err => {
      Sentry.captureException(err)
      this.isLoading = false;
      this.ref.markForCheck();
      if (err?.error?.message != null) {
        this.messageService.add(this.toast(true, err.error.message));
      } else if (err?.status == 500) {
        this.messageService.add(this.toast(true, 'Internal Server Error'));
      }
    })
  }

  calculatePriceToCarrier(i: number) {
    let f = (this.form.get('bulkEditOrders') as FormArray).controls;
    this.calculateBalance(f, i)
    let terms = this.form.get('paymentTerms')?.value,
      priceToCarrier = f[i].get('priceToCarrier')?.value,
      wash = this.modal[i]?.wash,
      balanceDue = f[i].get('calculatedBalance')?.value,
      customerChargedType = this.modal[i]?.customerChargedType,
      carrierPaymentType = this.modal[i]?.carrierPaymentType

    if (wash == null)
      wash = 0;

    if ((customerChargedType == 3 && (carrierPaymentType == 1)) || (customerChargedType == 4 && (carrierPaymentType == 2))) {
      if ((+priceToCarrier > +balanceDue)) {
        if (terms == 1 || terms == 7) {  // 1 => 2 ach , 2 => 5 ach
          f[i].get('calculatedPriceToCarrier')?.setValue(((+priceToCarrier - +balanceDue) - +wash - (0.05 * (+priceToCarrier - +balanceDue))).toFixed(2).toString());
        } else if (terms == 2) {
          f[i].get('calculatedPriceToCarrier')?.setValue(((+priceToCarrier - +balanceDue) - +wash - (0.03 * (+priceToCarrier - +balanceDue))).toFixed(2).toString());
        } else {
          f[i].get('calculatedPriceToCarrier')?.setValue(((+priceToCarrier) - +wash - +balanceDue).toFixed(2).toString());
        }
      } else if (((+priceToCarrier == +balanceDue) || +priceToCarrier < +balanceDue)) {
        f[i].get('calculatedPriceToCarrier')?.setValue((0).toString());
      }
    }
    else {
      if (terms == 1 || terms == 7) {
        f[i].get('calculatedPriceToCarrier')?.setValue((+priceToCarrier - (0.05 * (+priceToCarrier)) - +wash).toFixed(2).toString());
      } else if (terms == 2) {
        f[i].get('calculatedPriceToCarrier')?.setValue((+priceToCarrier - (0.03 * (+priceToCarrier)) - +wash).toFixed(2).toString());
      } else {
        f[i].get('calculatedPriceToCarrier')?.setValue(((+priceToCarrier) - +wash).toFixed(2).toString());
      }
    }
    this.calculateCompanyProfit(i)
    this.setBrokerFee(false, f, i)
  }

  calculateCompanyProfit(i: number) {
    let f: any = (this.form.get('bulkEditOrders') as FormArray).controls;
    let price = 0;
    if (this.modal[i]?.price)
      price = this.modal[i]?.price ? parseFloat(this.modal[i]?.price) : 0;

    let deposit = 0;
    if (this.modal[i]?.deposit)
      deposit = this.modal[i]?.deposit ? parseFloat(this.modal[i]?.deposit) : 0;

    let priceToCarrier = 0;
    if (f[i].contains('priceToCarrier'))
      priceToCarrier = f[i].get('priceToCarrier').value ? parseFloat(f[i].get('priceToCarrier').value) : 0;

    let customerChargedType = null;
    if (this.modal[i]?.customerChargedType)
      customerChargedType = this.modal[i]?.customerChargedType;

    let depositBy = null;
    if (this.modal[i]?.depositBy)
      depositBy = this.modal[i]?.depositBy;
    let fscPaidBy = null;
    if (this.modal[i]?.fscPaidBy) {
      fscPaidBy = this.modal[i]?.fscPaidBy;
    }

    let brokerFeePaymentMethod = null;
    if (f[i].contains('brokerFeePaymentMethod')) {
      brokerFeePaymentMethod = f[i].get('brokerFeePaymentMethod')?.value;
    }

    let balanceDue = 0;
    if (f[i].contains('calculatedBalance')) {
      balanceDue = f[i].get('calculatedBalance').value ? parseFloat(f[i].get('calculatedBalance').value) : 0;
    }

    if (price == null || customerChargedType == 0 || customerChargedType == null) {
      f[i].get('calculatedCompanyProfit').setValue(null);
      return;
    }
    let result = null;
    let profit = null;
    switch (customerChargedType) {
      case 3: // COD
        result = deposit + (balanceDue - priceToCarrier);
        break;
      case 1: // PrePay
        result = deposit + (balanceDue - priceToCarrier);
        break;
      case 2: // Invoice
        result = deposit + (balanceDue - priceToCarrier);
        break;
      case 4: // COP
        result = deposit + (balanceDue - priceToCarrier);
        break;
      case 0: // NA
      default:
        break;
    }

    if (depositBy == PaymentMethod['Credit Card'] || depositBy == PaymentMethod.Paypal || fscPaidBy == PaymentMethod['Credit Card'] || fscPaidBy == PaymentMethod.Paypal) {
      let subtractCommission = 0;
      if (deposit) {
        subtractCommission = (result) + (-(deposit * (environment.percentage_of_deduction / 100)));
      } else {
        subtractCommission = (result) + (-(balanceDue * (environment.percentage_of_deduction / 100)));
      }
      profit = subtractCommission;
    } else {
      profit = result;
    }

    // If broker fee paid from cc or pp then deduct it from profit
    if ((brokerFeePaymentMethod) && (+brokerFeePaymentMethod == PaymentMethod['Credit Card'] || +brokerFeePaymentMethod == PaymentMethod.Paypal)) {
      const brokerFee: any = this.setBrokerFee(true, f, i);
      if (brokerFee !== null) {
        profit = (profit) + (-((+brokerFee) * (environment.percentage_of_deduction / 100)));
      }
    }

    f[i].get('calculatedCompanyProfit').setValue((Math.sign(profit) * Math.abs(Math.ceil(Math.sign(profit) * profit * 100) / 100)).toFixed(2));
  }

  calculateBalance(f: any, i: number) {
    let price = this.modal[i]?.price
    let deposit = this.modal[i]?.deposit;

    if (deposit == null) {
      deposit = 0;
    }

    if (price == null) {
      f[i].get('calculatedBalance').setValue(null);
    } else {
      f[i].get('calculatedBalance').setValue((+price - +deposit).toFixed(2).toString());
    }

    f[i].get('calculatedBalance').updateValueAndValidity();
  }

  setBrokerFee(getBrokerfee: boolean = false, f: any, i: number) {
    let customerChargedType = this.modal[i]?.customerChargedType,
      carrierPaymentType = this.modal[i]?.carrierPaymentType,
      priceToCarrier = f[i].get('priceToCarrier')?.value,
      balanceDue = f[i].get('calculatedBalance')?.value,
      depositRequired = this.modal[i]?.depositRequired;  //2-yes, 3-no


    if (customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier) {
      f[i].get('brokerFeePaid')?.setValue(1);
      this.setBrokerFeePaidAndMethod(1, f[i])
      return getBrokerfee ? null : f[i].get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : f[i].get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 3 && depositRequired == 2 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier) {
      f[i].get('brokerFeePaid')?.setValue(1);
      this.setBrokerFeePaidAndMethod(1, f[i])
      return getBrokerfee ? null : f[i].get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier) {
      return getBrokerfee ? 0 : f[i].get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : f[i].get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 3 && depositRequired == 3 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier) {
      return getBrokerfee ? 0 : f[i].get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier) {
      f[i].get('brokerFeePaid')?.setValue(1);
      this.setBrokerFeePaidAndMethod(1, f[i])
      return getBrokerfee ? null : f[i].get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : f[i].get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 4 && depositRequired == 2 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier) {
      f[i].get('brokerFeePaid')?.setValue(1);
      this.setBrokerFeePaidAndMethod(1, f[i])
      return getBrokerfee ? null : f[i].get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier) {
      return getBrokerfee ? 0 : f[i].get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : f[i].get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 4 && depositRequired == 3 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier) {
      return getBrokerfee ? 0 : f[i].get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 2 && depositRequired == 3 && carrierPaymentType == 4) {
      f[i].get('brokerFeePaid')?.setValue(1);
      this.setBrokerFeePaidAndMethod(1, f[i])
      return getBrokerfee ? null : f[i].get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 1 && depositRequired == 2 && carrierPaymentType == 4 && +balanceDue < +priceToCarrier) {
      f[i].get('brokerFeePaid')?.setValue(1);
      this.setBrokerFeePaidAndMethod(1, f[i])
      return getBrokerfee ? null : f[i].get('brokerFee')?.setValue(null)
    }
    else {
      if (+balanceDue > +priceToCarrier) {
        return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : f[i].get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
      } else {
        f[i].get('brokerFeePaid')?.setValue(1);
        this.setBrokerFeePaidAndMethod(1, f[i])
        return getBrokerfee ? null : f[i].get('brokerFee')?.setValue(null)
      }
    }
  }

  setBrokerFeePaidAndMethod(v, f) {
    if (v == this.YesNoNA.Yes) {
      f.get('brokerFeePaidDate').setValidators([Validators.required]);
      f.get('brokerFeePaidDate').markAsDirty();
      f.get('brokerFeePaidDate').markAsTouched();
      f.get('brokerFeePaidDate').updateValueAndValidity();

      f.get('brokerFeePaymentMethod').setValidators([Validators.required]);
      f.get('brokerFeePaymentMethod').markAsDirty();
      f.get('brokerFeePaymentMethod').markAsTouched();
      f.get('brokerFeePaymentMethod').updateValueAndValidity();

    } else {
      f.get('brokerFeePaidDate').setValue(null);
      f.get('brokerFeePaidDate').clearValidators();
      f.get('brokerFeePaidDate').updateValueAndValidity();

      f.get('brokerFeePaymentMethod').setValue(null);
      f.get('brokerFeePaymentMethod').clearValidators();
      f.get('brokerFeePaymentMethod').updateValueAndValidity();
    }
  }

  onNoActiveDriverFlagChange(val: boolean){
    this.hasActiveDriver = val;
  }

  ngOnDestroy(): void {
    this.forbiddenSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private resetDriverFormsAndValidation(): void {
    this.dynamicBulkUploadrray.controls.forEach((group) => {
      if (group instanceof FormGroup && group.get("orderDriverDetail")) {
        const orderDriverDetailArray = group.get(
          "orderDriverDetail"
        ) as FormArray;
        orderDriverDetailArray.clear();
        const newDriverForm = this.fh.getDriverTruckOverhualForm(null, this.form.get("selectedCarrier")?.value?.carrierStatus, true);
        orderDriverDetailArray.push(newDriverForm);
        
        // Immediately validate the new form
        newDriverForm.markAllAsTouched();
        newDriverForm.updateValueAndValidity();
      }
    });
    this.ref.markForCheck();
  }

  loadCarrierDriversAndPolicies(carrierId: number): void {
      if (carrierId) {
        this.userService
          .getCarrierDrivers(carrierId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((response) => {
              this.policyDetails = response.body.policyDetails;
              this.isPolicyEmpty = this.policyDetails?.length === 0;
              this.isPolicyExpired = this.policyDetails?.some(
                (item) => item.isExpire
              );
              this.isTransitCompleteCarrier = response.body.carrierUploadComplete;
          });
    }
  }

}

@NgModule({
  declarations: [
    DynamicBulkUploadComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleControlModule,
    DynamicDateFormModule,
    DriverTruckOverhualFormModule,
    LoadingModule,
    DynamicValueModule,
    AutoCompleteModule,
    DynamicControlErrorModule,
    UploadsModule,
    DialogModule,
    ConfirmDeleteDialogModule,
    SanitizeInputDirective
  ],
  exports: [
    DynamicBulkUploadComponent
  ]
})
export class DynamicBulkUploadModule { }
